

export type ModalV5_Params = {


    // component           : any,

    toggleCallback?         : callback
    name?                   : string
    placement?              : ModalPlacement

    isOutsideClickDisabled? : boolean       // if set to true - will ignore click outside of mobile i.e. close ONLY with 'x' button
}

export enum  ModalPlacement {

    MIDDLE          = 1,
    TOP             = 2,
}
